import { COMMON_LOADER_GETTER_IS_LOADING } from '@/store/modules/common/loader/common.loader.constant'

export default {
  [COMMON_LOADER_GETTER_IS_LOADING]: ({ isLoading }) => {
    return isLoading
  }
}
